import React from 'react'
import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import "@material/react-text-field/dist/text-field.css";
import { useState } from "react";

const useStylesNarrow = makeStyles((theme) => ({
  root: {
    color: "#9d9db1",
    border2: "1px solid #e2e2e1",
    overflow2: "hidden",
    borderRadius: 4,
    backgroundColor: "#f3f6f9",
    "&:hover2": {
      backgroundColor: "#f3f6f9",
    },
    "&$focused": {
      backgroundColor: "#f3f6f9",
      borderColor: theme.palette.primary.main,
    },
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#f3f6f9",
      borderColor: "#ccd6e3",
      color: "#9d9db1",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccd6e3",
      color: "#9d9db1",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccd6e3",
      color: "#9d9db1",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccd6e3",
      color: "#9d9db1",
    },
    "& .MuiFormLabel-root": {
      color: "#9d9db1",
    },
    "& .MuiFormLabel-root.Mui-focused": {
      color: "#9d9db1",
    },
    "&   .MuiInputLabel-outlined": {
      zIndex: 1,
      transform: "translate(14px, 10px) scale(1)",
      pointerEvents: "none",
    },

    "&   .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      zIndex: 1,
      transform: "translate(14px, -6px) scale(0.75)",
      pointerEvents: "none",
    },
    "& .MuiOutlinedInput-input": {
      padding: "10.5px 14px",
    },
  },

  rootFilled: {
    color: "#1f4a94",
    border2: "1px solid #e2e2e1",
    overflow2: "hidden",
    borderRadius: 4,
    backgroundColor: "#ffffff",
    "&:hover2": {
      backgroundColor: "#ffffff",
    },
    "&$focused": {
      backgroundColor: "#ffffff",
      borderColor: theme.palette.primary.main,
    },
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#ffffff",
      borderColor: "#1f4a94",
      color: "#1f4a94",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#1f4a94",
      color: "#1f4a94",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#1f4a94",
      color: "#1f4a94",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#1f4a94",
      color: "#1f4a94",
    },
    "& .MuiFormLabel-root, & .MuiFormLabel-root.Mui-focused": {
      color: "#1f4a94",
    },

    "&   .MuiInputLabel-outlined": {
      zIndex: 1,
      transform: "translate(14px, 10px) scale(1)",
      pointerEvents: "none",
    },

    "&   .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      zIndex: 1,
      transform: "translate(14px, -6px) scale(0.75)",
      pointerEvents: "none",
    },
    "& .MuiOutlinedInput-input": {
      padding: "10.5px 14px",
    },
  },

  rootEror: {
    color: "#ff0707",
    border2: "1px solid #e2e2e1",
    overflow2: "hidden",
    borderRadius: 4,
    backgroundColor: "#ffffff",
    "&:hover2": {
      backgroundColor: "#ffffff",
    },
    "&$focused": {
      backgroundColor: "#ffffff",
      borderColor: theme.palette.primary.main,
    },
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#ffffff",
      borderColor: "#ff0707",
      color: "#1f4a94",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ff0707",
      color: "#ff0707",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ff0707",
      color: "#ff0707",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ff0707",
      color: "#ff0707",
    },
    "& .MuiFormLabel-root, & .MuiFormLabel-root.Mui-focused": {
      color: "#ff0707",
    },
    "&   .MuiInputLabel-outlined": {
      zIndex: 1,
      transform: "translate(14px, 10px) scale(1)",
      pointerEvents: "none",
    },

    "&   .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      zIndex: 1,
      transform: "translate(14px, -6px) scale(0.75)",
      pointerEvents: "none",
    },
    "& .MuiOutlinedInput-input": {
      padding: "10.5px 14px",
    },
  },
  focused: {},
}));

const useStyles = makeStyles((theme) => ({
  root: {
    color: "#9d9db1",
    border2: "1px solid #e2e2e1",
    overflow2: "hidden",
    borderRadius: 4,
    backgroundColor: "#f3f6f9",
    "&:hover2": {
      backgroundColor: "#f3f6f9",
    },
    "&$focused": {
      backgroundColor: "#f3f6f9",
      borderColor: theme.palette.primary.main,
    },
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#f3f6f9",
      borderColor: "#ccd6e3",
      color: "#9d9db1",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccd6e3",
      color: "#9d9db1",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccd6e3",
      color: "#9d9db1",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ccd6e3",
      color: "#9d9db1",
    },
    "& .MuiFormLabel-root.Mui-focused": {
      color: "#9d9db1",
    },
  },

  rootFilled: {
    color: "#1f4a94",
    border2: "1px solid #e2e2e1",
    overflow2: "hidden",
    borderRadius: 4,
    backgroundColor: "#ffffff",
    "&:hover2": {
      backgroundColor: "#ffffff",
    },
    "&$focused": {
      backgroundColor: "#ffffff",
      borderColor: theme.palette.primary.main,
    },
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#ffffff",
      borderColor: "#1f4a94",
      color: "#1f4a94",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#1f4a94",
      color: "#1f4a94",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#1f4a94",
      color: "#1f4a94",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#1f4a94",
      color: "#1f4a94",
    },
    "& .MuiFormLabel-root, & .MuiFormLabel-root.Mui-focused": {
      color: "#1f4a94",
    },
  },

  rootEror: {
    color: "#ff0707",
    border2: "1px solid #e2e2e1",
    overflow2: "hidden",
    borderRadius: 4,
    backgroundColor: "#ffffff",
    "&:hover2": {
      backgroundColor: "#ffffff",
    },
    "&$focused": {
      backgroundColor: "#ffffff",
      borderColor: theme.palette.primary.main,
    },
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#ffffff",
      borderColor: "#ff0707",
      color: "#1f4a94",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ff0707",
      color: "#ff0707",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ff0707",
      color: "#ff0707",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ff0707",
      color: "#ff0707",
    },
    "& .MuiFormLabel-root, & .MuiFormLabel-root.Mui-focused": {
      color: "#ff0707",
    },
  },
  focused: {},
}));

export const OutlineInput = (props) => {
  const [value, setValue] = useState(props.value);
  const styleNarrow = useStylesNarrow();
  const style = useStyles();
  const customStyle = props.style === "narrow" ? styleNarrow : style;

  const handleInput = (e) => {
    setValue(e.target.value);
    props.onInputChange(props.name, e.target.value);
  };

  const handleInputOnBlur = (e) => {
    setValue(e.target.value);
    props.onInputChange(props.name, e.target.value, "onBlur");
  };

  return (
    <>
      <TextField
        onChange={handleInput}
        onClick={() => {}}
        onDoubleClick={() => {}}
        onFocus={() => {}}
        onBlur={handleInputOnBlur}
        onCopy={() => {}}
        value={value}
        label={props.label}
        disabled={props.readOnly}
        options={props.options}
        variant={!props.readOnly ? "outlined" : "outlined"}
        fullWidth
        autoFocus={false}
        className={
          props.validStatus == 402 || props.validStatus == 400
            ? customStyle.rootEror
            : !props.readOnly && value && value !== ""
            ? customStyle.rootFilled
            : customStyle.root
        }
        inputProps={{ maxLength: props.maxLength ? props.maxLength : "" }}
        InputProps={{
          disableUnderline: true,
          readOnly: props.readOnly,
          endAdornment: (
            <>
              {props?.endAdornment && <span className="mr-2 ">{props.endAdornment}</span>}
              {props.startAdornment && <>{props.startAdornment}</>}
            </>
          ),
        }}
        color="primary"
        autoComplete="off"
        name={props.name}
      ></TextField>

      <div></div>
    </>
  );
};
